/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EmailLink from '../../../../client/js/components/links/EmailLink'
import PhoneLink from '../../../../client/js/components/links/PhoneLink'
import { fetchCustomer } from '../../lib/rest/customerAPIClient'
import { useQuery } from '@tanstack/react-query'
import { Group, GroupProps } from '@mantine/core'

export type CustomerInfoProps = GroupProps & {
  customer?: Partial<Customer>
  customerId?: number
}

function CustomerInfo (props: CustomerInfoProps) {
  const { customerId, customer, ...others } = props

  const query = useQuery({
    enabled: customerId != null,
    queryKey: ['customer', customerId],
    queryFn: () => fetchCustomer(customerId)
  })

  const data = customer || query.data

  return data
    ? <Group gap="xs" fz="sm" {...others}>
      {data.mobile
        ? <Group gap="xs">
          <FontAwesomeIcon
            fixedWidth
            icon={faMobileAlt}
          />
          <PhoneLink inherit phone={data.mobile} />
        </Group>
        : null}

      {data.phone
        ? <Group gap="xs">
          <FontAwesomeIcon
            fixedWidth
            icon={faPhoneAlt}
          />
          <PhoneLink inherit phone={data.phone} />
        </Group>
        : null}

      {data.email
        ? <Group gap="xs">
          <FontAwesomeIcon
            fixedWidth
            icon={faEnvelope}
          />
          <EmailLink inherit email={data.email} />
        </Group>
        : null}

      {data.email2
        ? <Group gap="xs">
          <FontAwesomeIcon
            fixedWidth
            icon={faEnvelope}
          />
          <EmailLink inherit email={data.email2} />
        </Group>
        : null}
    </Group>
    : null
}

export default CustomerInfo
